import TextMaskSdk from '../components/TextMask/corvid/TextMask.corvid';


const TextMask = {
  sdk: TextMaskSdk
};


export const components = {
  ['TextMask']: TextMask
};

